import {
  computeCorrectScore,
  computeScore,
  findMatches,
  getCounts,
  getText,
} from "./helper";
import {
  metaDataScoreWeights,
  metaDescLength,
  metaTitleLength,
} from "./metaDataHelper";

// Meta Title Keyword Inclusion Check
const metaTitleKeywordInclusion = (formikProps) => {
  let metaTitle = getText(formikProps.values.meta_title).trim();
  if (metaTitle.length == 0) {
    return { score: -1, percentage: -1, text: "Please add meta title" };
  }

  if (!formikProps.values.seo_request.trim()) {
    return { score: 0, percentage: 0 };
  }
  const seoRequest = getText(formikProps.values.seo_request.trim())
    .toLowerCase()
    .split(" ");
  let count = 0;

  seoRequest.forEach((word) => {
    const matches = findMatches(metaTitle, word);

    if (matches) {
      count += 1;
    }
  });

  if (count == 0) {
    return {
      score: 0,
      percentage: 0,
      text: "The target request does not appear in the meta title. Add it!",
    };
  } else {
    const score = (count / seoRequest.length) * 100;
    if (count > seoRequest.length || score == 100) {
      return {
        score: 100,
        percentage: 100,
        text: "The target request fully appears in the meta title. That’s perfect!",
      };
    } else {
      return {
        score: 50,
        percentage: score,
        text: "The target request partially appears in the meta title. Try to add the rest!",
      };
    }
  }
};

// Meta Title Length Check
const metaTitleLengthCheck = (formikProps) => {
  let metaTitle = getText(formikProps.values.meta_title).trim();
  if (metaTitle.length == 0) {
    return {
      score: -1,
      percentage: -1,
      chars: 0,
      words: 0,
      text: "Please add meta title",
    };
  }
  return metaTitleLength(metaTitle);
};

// Meta Title and H1 Diff
const metaTitleDifferenceCheck = (formikProps) => {
  let metaTitle = getText(formikProps.values.meta_title).trim();
  if (metaTitle.length == 0) {
    return { score: -1, missingWords: null };
  }

  metaTitle = new Set(metaTitle.toLowerCase().split(/\s+/));
  const title = new Set(
    getText(formikProps.values.h1_title).trim().toLowerCase().split(/\s+/)
  );
  const missingWordsInTitle = [...metaTitle].filter((word) => !title.has(word));
  const missingWordsInMetaTitle = [...title].filter(
    (word) => !metaTitle.has(word)
  );
  const totalMissingWords =
    missingWordsInMetaTitle.length + missingWordsInTitle.length;

  if (totalMissingWords == 0) {
    return {
      score: 0,
      missingWords: missingWordsInMetaTitle.concat(missingWordsInTitle).length,
    };
  }
  if (totalMissingWords == 1) {
    return {
      score: 50,
      missingWords: missingWordsInMetaTitle.concat(missingWordsInTitle).length,
    };
  }
  if (totalMissingWords > 1) {
    return {
      score: 100,
      missingWords: missingWordsInMetaTitle.concat(missingWordsInTitle).length,
    };
  }
};

// Meta Desc keyword Inclusion
const metaDescriptionKeywordInclusion = (formikProps) => {
  let metaDescription = getText(formikProps.values.meta_description).trim();
  if (metaDescription.length === 0) {
    return { score: -1, percentage: -1 };
  }

  if (!formikProps.values.seo_request.trim()) {
    return { score: 0, percentage: 0 };
  }
  const seoRequest = getText(formikProps.values.seo_request.trim())
    .toLowerCase()
    .split(" ");
  let count = 0;

  seoRequest.forEach((word) => {
    const matches = findMatches(metaDescription, word);

    if (matches) {
      count += 1;
    }
  });

  if (count === 0) {
    return { score: 0, percentage: 0 };
  } else {
    const score = (count / seoRequest.length) * 100;
    if (count > seoRequest.length || score === 100) {
      return { score: 100, percentage: 100 };
    } else {
      return { score: 50, percentage: score };
    }
  }
};

// Meta Desc Length Check
const metaDescriptionLengthCheck = (formikProps) => {
  let metaDescription = getText(formikProps.values.meta_description).trim();
  if (metaDescription.length == 0) {
    return {
      score: -1,
      chars: 0,
      words: 0,
      text: "Please add meta description",
    };
  }
  return metaDescLength(metaDescription);
};

// Score Calculation
export const startMetaDataAnalysis = (formikProps) => {
  const metaTitleKeyword = metaTitleKeywordInclusion(formikProps);
  const metaTitleLength = metaTitleLengthCheck(formikProps);
  const metaTitleDifference = metaTitleDifferenceCheck(formikProps);
  const metaDescriptionKeyword = metaDescriptionKeywordInclusion(formikProps);
  const metaDescriptionLength = metaDescriptionLengthCheck(formikProps);
  let totalScore = computeCorrectScore(
    [
      metaTitleKeyword.percentage,
      metaTitleLength.percentage,
      metaTitleDifference.score,
      metaDescriptionKeyword.percentage,
      metaDescriptionLength.score,
    ],
    metaDataScoreWeights
  );

  return {
    metaTitle_keyword: metaTitleKeyword,
    metaTitle_length: metaTitleLength,
    metaTitle_difference: metaTitleDifference,
    metaDescription_keyword: metaDescriptionKeyword,
    metaDescription_length: metaDescriptionLength,
    total_score: Math.round(totalScore),
  };
};
